import type { Location, NavigateFunction } from 'react-router-dom';

/** Keep auth query/hash when leaving a ticket for the support home. */
export function navigateToSupportHome(navigate: NavigateFunction, location: Location): void {
  navigate({
    pathname: '/',
    search: location.search,
    hash: location.hash,
  });
}

export function supportHomePath(location: Pick<Location, 'search' | 'hash'>): string {
  return `/${location.search || ''}${location.hash || ''}`;
}
